import React, { useEffect } from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import { CMASummaryFilters } from 'components/CMASummary/types';
import FilterDropdownHeader from 'components/lib/FilterDropdownHeader';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import { CMASummaryContractsFilterContext } from './CMASummaryContractsFilterContext';
import CMASummaryFilterContractDisplay from './CMASummaryFilterContractDisplay';
import CMASummaryFilterContractSelection from './CMASummaryFilterContractSelection';
import { COMMUNITY_CONTRACT_SELECTION_TYPE, CONTRACT_DISPLAY_TYPES } from '../../../../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .ant-form-item .ant-form-item-control-input {
    min-height: 0;
  }
`;

type Props = {
  open: boolean;
  onClose: () => void;
};

const CMASummaryContractsFilterDropdown = ({ open, onClose }: Props) => {
  const [form] = Form.useForm();
  const { viewFilters, setViewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  const initialValues = {
    form,
    contractDisplayType: filters.contractDisplayType,
    contractSelectionType: filters.contractSelectionType,
    communityContractSlugs: filters.communityContractSlugs,
  };

  useEffect(() => {
    if (filters) {
      form.setFieldsValue({
        contractDisplayType: filters.contractDisplayType,
        contractSelectionType: filters.contractSelectionType,
        communityContractSlugs: filters.communityContractSlugs,
      });
    }
  }, [filters]);

  const onSubmit = (formValues: any) => {
    setViewFilters({
      ...viewFilters,
      ...formValues,
    });
    onClose();
  };

  const onReset = () => {
    form.setFieldsValue({
      contractDisplayType: CONTRACT_DISPLAY_TYPES.MY_CONTRACTS,
      contractSelectionType: COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE,
      communityContractSlugs: [],
    });
  };

  return (
    <Form form={form} initialValues={initialValues} onFinish={onSubmit}>
      <CMASummaryContractsFilterContext.Provider
        value={{
          form,
          contractDisplayType: filters.contractDisplayType,
          contractSelectionType: filters.contractSelectionType,
          communityContractSlugs: filters.communityContractSlugs,
        }}
      >
        <Container>
          <FilterDropdownHeader onReset={onReset} />
          <CMASummaryFilterContractDisplay />
          <Form.Item name="communityContractSlugs" noStyle>
            <CMASummaryFilterContractSelection />
          </Form.Item>
        </Container>
      </CMASummaryContractsFilterContext.Provider>
    </Form>
  );
};

export default CMASummaryContractsFilterDropdown;
